import { CountryEntity } from 'api/types/entity';

export enum FirstHeadOptionType {
  delete = 'delete',
  archive = 'archive',
  dearchive = 'dearchive',
}

export interface FirstHeadItem {
  id: string;
  name: string;
  residentialCountry?: CountryEntity;
  registrationCountry?: CountryEntity;
  createdAt: Date;
  archived: boolean;
  position?: string;
  expirationDate?: string;
}
